import { Link } from 'react-router-dom';
import { useTranslation } from '../../../i18n/useTranslation';
import { routes } from '../../../Utils/routes';
import './Welcome.css';

/**
 * Where Paddle sends the browser after a completed overlay checkout from the
 * pricing page (`settings.successUrl`).
 *
 * This page does not itself grant anything: the webhook is what activates the
 * subscription, out of band, and may not have landed by the time this screen
 * renders. It is a receipt, not a gate.
 */
export function Welcome() {
  const { tr } = useTranslation();
  return (
    <div className="marketing welcome-page">
      <h1>{tr('welcomeTitle')}</h1>
      <p className="marketing-copy">{tr('welcomeLede')}</p>
      <p className="marketing-copy welcome-note">{tr('welcomeNote')}</p>
      <Link className="primary-button" to={routes.app}>{tr('welcomeCta')}</Link>
    </div>
  );
}
